import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { sort } from '../../util'
import { Col, Grid, Row } from 'react-bootstrap'
import ActivityTable from '../../ActivityTable/ActivityTable'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { getBrandAmbassadorActivity } from './gql'
import { normalizeGraphQLConnection } from '../../../../../../shared/graphql/utils'

const ActivitySection = ({
  ambassadorId,
  match,
  filterActivitiesByStatus,
  activitiesSortBy,
}) => {
  const history = useHistory()
  const [missions, setMissions] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  const getAllData = async () => {
    let fetchArgs = { ambassadorId, first: 50 }
    const { data } = await getBrandAmbassadorActivity(fetchArgs)

    let ambassadorActivities = normalizeGraphQLConnection(
      data.brandAmbassador.missions,
    )
    let pageInfo = data.brandAmbassador.missions.pageInfo
    while (pageInfo.hasNextPage) {
      fetchArgs.after = pageInfo.endCursor
      const { data: newData } = await getBrandAmbassadorActivity(fetchArgs)
      pageInfo = newData.brandAmbassador.missions.pageInfo

      ambassadorActivities = [
        ...ambassadorActivities,
        ...normalizeGraphQLConnection(newData.brandAmbassador.missions),
      ]
    }

    setMissions(ambassadorActivities)
    setIsLoaded(true)
  }

  useEffect(() => {
    getAllData()
  }, [])

  const ambassadorDataMapper = ambassadorData => {
    const data = ambassadorData.map(mission => ({
      ...mission,
      timeStart: mission.timeRangeStart,
      checkout: { flyerQuantity: mission.totalFlyersDistributed },
      conversions: mission.conversions ? mission.conversions.nodes : [],
      isSpied:
        mission.spyInformation &&
        mission.spyInformation.spyDetails &&
        mission.spyInformation.spyDetails.checkInTime,
    }))

    return data
  }

  let ambassadorActivities = ambassadorDataMapper(missions)
  ambassadorActivities = filterActivitiesByStatus(ambassadorActivities)
  ambassadorActivities = sort({
    data: ambassadorActivities,
    sortBy: activitiesSortBy,
  })

  return (
    <AmbassadorSection className="no-padding overflow-auto">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Activity</SectionTitle>
          </Col>
        </Row>
        {missions.length ? (
          <Row>
            <Col xs={12} className="full-width-table">
              <ActivityTable
                history={history}
                match={match}
                ambassadorActivities={ambassadorActivities}
              />
            </Col>
          </Row>
        ) : isLoaded ? (
          <p className="not-found">No activities found</p>
        ) : (
          <p className="not-found">Loading</p>
        )}
      </Grid>
    </AmbassadorSection>
  )
}

export default ActivitySection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/ActivitySection/index.js